<template>
  <interact resizable :resizeOption="resizeOption" :data-app-theme="$store.getters.theme" draggable :dragOption="dragOption" class="resize-drag portfolio-shell" :style="style" @dragmove="dragmove" @resizemove="resizemove" :class="{ fullscreen: $store.getters.isFullscreenPortfolio }">
    <div ref="container" class="portfolio-container" :class="{ fullscreen: $store.getters.isFullscreenPortfolio }">
      <header class="portfolio-toolbar app-toolbar" @dblclick.self="$store.commit('toggleFullscreenPortfolio')">
        <div class="window-controls"><button class="traffic red" type="button" aria-label="Close Portfolio" @click="closePortfolio"></button><button class="traffic yellow" type="button" aria-label="Minimize Portfolio" @click="closePortfolio"></button><button class="traffic green" type="button" aria-label="Toggle fullscreen" @click="$store.commit('toggleFullscreenPortfolio')"></button></div>
        <span>Portfolio</span>
      </header>
      <div class="portfolio-layout">
        <nav class="portfolio-nav" aria-label="Portfolio categories"><button v-for="tab in tabs" :key="tab.id" type="button" :aria-pressed="selectedTab === tab.id" :class="{ selected: selectedTab === tab.id }" @click="selectedTab = tab.id"><i :class="tab.icon" aria-hidden="true"></i><span class="desktop-label">{{ tab.label }}</span><span class="mobile-label">{{ tab.mobile }}</span></button></nav>
        <main class="portfolio-content">
          <h1>{{ pageTitle }}</h1><p class="page-intro">A selection of projects, products, and ideas.</p>
          <template v-if="selectedTab === 'Discover'">
            <section class="featured-banner" aria-label="Explore my work"><div class="banner-copy"><h2>Explore My Work</h2><p>Web experiences, products, and design.</p></div><img src="../assets/Biography/TechWorkspace.jpg" alt="A workspace with software development screens" /></section>
            <section class="featured-projects" aria-label="Featured projects"><button v-for="project in featuredProjects" :key="project.id" type="button" class="feature-card" @click="previewProject = project"><img :src="project.image" :alt="project.title + ' project preview'" /><div><h2>{{ project.title }}</h2><p>{{ project.description }}</p></div></button></section>
          </template>
          <section class="project-section" aria-label="Projects"><h2>{{ selectedTab === 'Discover' ? 'Selected Projects' : 'Projects' }}</h2><div class="project-list"><article v-for="project in currentProjects" :key="project.id" class="project-row"><img :src="project.image" alt="" /><div class="project-copy"><h3>{{ project.title }}</h3><p>{{ project.description }}</p></div><button type="button" class="view-button" :aria-label="'View ' + project.title" @click="previewProject = project">View</button></article></div></section>
        </main>
      </div>
      <div v-if="previewProject" class="project-preview" role="region" :aria-label="previewProject.title" @keydown.esc="previewProject = null"><button type="button" class="preview-close" @click="previewProject = null">Back to projects</button><h2>{{ previewProject.title }}</h2><p>{{ previewProject.description }}</p><img :src="previewProject.image" :alt="previewProject.title + ' full project image'" /></div>
      <div class="resizer resizer-b"></div><div class="resizer resizer-l"></div><div class="resizer resizer-t"></div><div class="resizer resizer-r"></div>
    </div>
  </interact>
</template>
<style scoped>
.portfolio-shell { --pf-bg:#fafafb; --pf-sidebar:#ececee; --pf-toolbar:#f6f6f7; --pf-surface:#fff; --pf-text:#1d1d1f; --pf-muted:#62626a; --pf-line:#dedee3; --pf-blue:#0064d8; --pf-selected:#d6e6ff; width:min(1200px,95vw); height:calc(var(--vh,1vh) * 100 - 150px); min-width:520px; min-height:300px; max-height:calc(100vh - 130px); }
.portfolio-shell[data-app-theme="dark"] { --pf-bg:#242426; --pf-sidebar:#303033; --pf-toolbar:#2c2c2f; --pf-surface:#2d2d30; --pf-text:#f5f5f7; --pf-muted:#b1b1b8; --pf-line:#454549; --pf-blue:#70b3ff; --pf-selected:#254263; color-scheme:dark; }
.portfolio-container { box-sizing:border-box; position:relative; display:flex; flex-direction:column; width:100%; height:100%; background:var(--pf-bg); color:var(--pf-text); border:1px solid var(--pf-line); border-radius:12px; overflow:hidden; box-shadow:0 20px 50px #0e182c55; }
.portfolio-toolbar { box-sizing:border-box; display:flex; height:52px; padding:0 18px; align-items:center; gap:32px; flex-shrink:0; background:var(--pf-toolbar); border-bottom:1px solid var(--pf-line); font-size:15px; font-weight:600; }
.window-controls { display:flex; gap:8px; }.traffic { padding:0; border:0; border-radius:50%; width:12px; height:12px; cursor:pointer; }.red { background:#ff5f57; }.yellow { background:#febc2e; }.green { background:#28c840; }
.portfolio-layout { display:grid; grid-template-columns:180px minmax(0,1fr); min-height:0; flex:1; }.portfolio-nav { background:var(--pf-sidebar); padding:20px 10px; border-right:1px solid var(--pf-line); }
.portfolio-nav button { display:flex; width:100%; align-items:center; gap:10px; border:0; border-radius:8px; background:none; color:var(--pf-muted); padding:13px 12px; font:inherit; font-size:13px; text-align:left; cursor:pointer; }.portfolio-nav button.selected { background:var(--pf-selected); color:var(--pf-blue); }.portfolio-nav i { width:18px; font-size:17px; }.mobile-label { display:none; }
.portfolio-content { padding:28px 30px 48px; overflow:auto; min-width:0; }h1,h2,h3,p { margin:0; }h1 { font-size:32px; letter-spacing:-.8px; }h2 { font-size:21px; letter-spacing:-.4px; }.page-intro { color:var(--pf-muted); font-size:14px; margin:8px 0 20px; line-height:1.5; }
.featured-banner { position:relative; isolation:isolate; display:flex; align-items:center; border-radius:14px; overflow:hidden; background:#18304c; color:#fff; min-height:200px; }.banner-copy { position:relative; z-index:1; padding:30px; width:100%; box-sizing:border-box; background:linear-gradient(90deg,#142b48f5 0%,#142b48b0 55%,#142b4830 100%); min-height:200px; display:flex; flex-direction:column; justify-content:center; }.banner-copy h2,.banner-copy p { max-width:26ch; }.banner-copy h2 { font-size:30px; line-height:1.15; }.banner-copy p { margin-top:12px; color:#e0e9f6; font-size:16px; line-height:1.5; }.featured-banner img { position:absolute; inset:0; z-index:-1; width:100%; height:100%; object-fit:cover; object-position:center; }
.featured-projects { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:16px; margin-top:18px; }.feature-card { position:relative; isolation:isolate; border:1px solid var(--pf-line); border-radius:14px; overflow:hidden; padding:0; background:var(--pf-surface); color:var(--pf-text); text-align:left; cursor:pointer; font:inherit; min-width:0; }.feature-card>div { position:relative; z-index:1; padding:18px; margin-top:0; background:var(--pf-surface); }.feature-card h2 { font-size:18px; overflow-wrap:anywhere; }.feature-card p { color:var(--pf-muted); margin-top:6px; font-size:13px; line-height:1.5; }.feature-card img { display:block; width:100%; height:140px; object-fit:cover; object-position:top; }
.project-section { margin-top:28px; padding-top:24px; border-top:1px solid var(--pf-line); }.project-list { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); column-gap:24px; margin-top:12px; }.project-row { display:flex; align-items:center; gap:12px; padding:16px 0; border-bottom:1px solid var(--pf-line); min-width:0; }.project-row>img { width:48px; height:48px; object-fit:cover; border-radius:10px; flex-shrink:0; }.project-copy { flex:1; min-width:0; }.project-copy h3 { font-size:14px; overflow-wrap:anywhere; line-height:1.35; }.project-copy p { font-size:12px; line-height:1.4; margin-top:4px; color:var(--pf-muted); }.view-button { flex-shrink:0; border:0; border-radius:20px; background:var(--pf-selected); color:var(--pf-blue); font:inherit; font-size:12px; font-weight:600; padding:8px 16px; cursor:pointer; }button:focus-visible { outline:2px solid var(--pf-blue); outline-offset:2px; }
.project-preview { position:absolute; inset:var(--app-toolbar-height) 0 0; z-index:2; background:var(--pf-bg); padding:24px; overflow:auto; }.preview-close { border:0; background:var(--pf-selected); color:var(--pf-blue); border-radius:8px; padding:10px 14px; margin-bottom:20px; cursor:pointer; font:inherit; }.project-preview p { color:var(--pf-muted); margin:10px 0 20px; }.project-preview img { width:100%; height:auto; border-radius:10px; }
.resizer { position:absolute; }.resizer-r { right:0; top:52px; bottom:0; width:4px; cursor:ew-resize; }.resizer-l { left:0; top:52px; bottom:0; width:4px; cursor:ew-resize; }.resizer-b { bottom:0; left:0; right:0; height:4px; cursor:ns-resize; }.fullscreen { width:100% !important; height:var(--fullscreen) !important; max-height:var(--fullscreen); }
@media(max-width:900px) { .project-list { grid-template-columns:minmax(0,1fr); }.portfolio-layout { grid-template-columns:160px minmax(0,1fr); }.portfolio-content { padding:24px; }.banner-copy { padding:24px; }.banner-copy h2 { font-size:26px; } }
@media(max-width:600px) { .portfolio-shell { width:90vw; height:calc(var(--vh,1vh) * 100 - 130px); min-width:0; min-height:250px; max-height:calc(100vh - 120px); }.portfolio-toolbar { height:46px; padding:0 14px; gap:20px; }.portfolio-layout { display:flex; flex-direction:column; }.portfolio-nav { display:flex; gap:3px; padding:8px; border-right:0; border-bottom:1px solid var(--pf-line); flex-shrink:0; }.portfolio-nav button { width:auto; flex:1; justify-content:center; padding:10px 3px; font-size:11px; gap:0; }.portfolio-nav i,.desktop-label { display:none; }.mobile-label { display:inline; }.portfolio-content { padding:20px 16px 40px; }h1 { font-size:27px; }.page-intro { font-size:13px; }.featured-banner { min-height:170px; position:relative; display:block; isolation:isolate; }.featured-banner img { position:absolute; inset:0; z-index:-1; min-height:0; }.banner-copy { padding:24px 20px; background:linear-gradient(90deg,#142b48f5,#142b48b0); min-height:170px; box-sizing:border-box; }.banner-copy h2 { font-size:25px; }.banner-copy p { max-width:23ch; font-size:14px; }.featured-projects { display:flex; overflow-x:auto; scroll-snap-type:x mandatory; gap:12px; padding-bottom:8px; }.feature-card { flex:0 0 94%; scroll-snap-align:start; }.feature-card img { height:130px; }.project-row { gap:10px; }.project-row>img { width:40px; height:40px; }.project-copy h3 { font-size:13px; }.view-button { padding:8px 12px; }.project-preview { inset:var(--app-toolbar-height) 0 0; padding:20px 16px; }.resizer { display:none; } }
</style>
<script>
import interact from "interactjs";
export default {
  props: {
    // shownProp: Boolean
  },
  data: function () {
    return {
      resizeOption: {
        edges: { top: true, left: true, bottom: true, right: true },
      },
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0,
      },
      dragOption: {
        modifiers: [
          interact.modifiers.restrictRect({
            restriction: "parent",
            endOnly: true,
          }),
        ],
        allowFrom: ".portfolio-toolbar",
        ignoreFrom: "button",
      },
      selectedTab: "Discover",
      previewProject: null,
      tabs: [{id:"Discover",label:"Discover",mobile:"Discover",icon:"far fa-compass"},{id:"RecentProjects",label:"Recent Projects",mobile:"Recent",icon:"far fa-clock"},{id:"DesignWork",label:"Design Work",mobile:"Design",icon:"far fa-image"},{id:"Development",label:"Development",mobile:"Development",icon:"fas fa-code"}],
      projects: {
        Discover: [
          {
            id: 1,
            title: "Zapbird.co",
            description: "Automate your CRM setup.",
            image: require("../assets/Portfolio/Zapbird.png"),
          },
          {
            id: 2,
            title: "Officefurnitureonline.com",
            description: "An online furniture marketplace.",
            image: require("../assets/Portfolio/OFW.png"),
          },
          {
            id: 3,
            title: "Altoglobal.com",
            description:
              "Corporate website for an international consulting firm.",
            image: require("../assets/Portfolio/AltoGlobal.png"),
          },
          {
            id: 4,
            title: "Altoshield.com",
            description: "Cybersecurity solutions provider.",
            image: require("../assets/Portfolio/AltoShield.png"),
          },
        ],
        RecentProjects: [
          {
            id: 3,
            title: "Altoglobal.com",
            description:
              "Corporate website for an international consulting firm.",
            image: require("../assets/Portfolio/AltoGlobal.png"),
          },
          {
            id: 4,
            title: "Altoshield.com",
            description: "Cybersecurity solutions provider.",
            image: require("../assets/Portfolio/AltoShield.png"),
          },
        ],
        DesignWork: [
          {
            id: 5,
            title: "Hunterfanlatinoamerica.com",
            description: "A regional eCommerce site for Hunter fans.",
            image: require("../assets/Portfolio/Hunter.png"),
          },
          {
            id: 3,
            title: "Altoglobal.com",
            description:
              "Corporate website for an international consulting firm.",
            image: require("../assets/Portfolio/AltoGlobal.png"),
          },
          {
            id: 4,
            title: "Altoshield.com",
            description: "Cybersecurity solutions provider.",
            image: require("../assets/Portfolio/AltoShield.png"),
          },
        ],
        Development: [
          {
            id: 6,
            title: "Custom React UI",
            description: "Built a fully custom UI using React.js",
            image: require("../assets/Portfolio/Hunter.png"),
          },
          {
            id: 7,
            title: "Experimental AI Projects",
            description: "AI-driven solutions and prototypes.",
            image: require("../assets/Portfolio/Hunter.png"),
          },
        ],
      },
      // values for interact.js transformation
      x: 0,
      y: 0,
    };
  },
  computed: {
    currentProjects() { return this.projects[this.selectedTab]; },
    pageTitle() { return { Discover:"Discover", RecentProjects:"Recent Work", DesignWork:"Design Work", Development:"In the Works" }[this.selectedTab]; },
    featuredProjects() { return [this.projects.Discover[0], this.projects.Discover[3]]; },
    style() {
      return {
        height: `${this.h}px`,
        width: `${this.w}px`,
        transform: `translate(${this.x}px, ${this.y}px)`,
        "--fullscreen": window.innerHeight - 30 + "px",
      };
    },
  },
  methods: {
    dragmove(event) {
      this.x += event.dx;
      this.y += event.dy;
      this.$store.commit("zIndexIncrement", "portfolio");
    },
    resizemove(event) {
      this.w = event.rect.width;
      this.h = event.rect.height;

      this.x += event.deltaRect.left;
      this.y += event.deltaRect.top;
    },
    dragMouseDown: function (event) {
      event.preventDefault();
      // get the mouse cursor position at startup:
      this.positions.clientX = event.clientX;
      this.positions.clientY = event.clientY;
      document.onmousemove = this.elementDrag;
      document.onmouseup = this.closeDragElement;
    },
    elementDrag: function (event) {
      event.preventDefault();
      this.positions.movementX = this.positions.clientX - event.clientX;
      this.positions.movementY = this.positions.clientY - event.clientY;
      this.positions.clientX = event.clientX;
      this.positions.clientY = event.clientY;
      // set the element's new position:
      this.$refs.draggableContainer.style.top =
        this.$refs.draggableContainer.offsetTop -
        this.positions.movementY +
        "px";
      this.$refs.draggableContainer.style.left =
        this.$refs.draggableContainer.offsetLeft -
        this.positions.movementX +
        "px";
    },
    closeDragElement() {
      document.onmouseup = null;
      document.onmousemove = null;
    },
    closePortfolio(e) {
      e.stopPropagation();
      this.$store.commit("toggleShownPortfolio", false);
      this.$store.commit("changeActiveWindow", "Finder");
    },
  },
  mounted: function () {
    // Query the element
    const ele = this.$refs.container;

    // The current position of mouse
    let x = 0;
    let y = 0;

    // The dimension of the element
    let w = 0;
    let h = 0;

    const mouseDownHandlerRight = function (e) {
      x = e.clientX;

      const styles = window.getComputedStyle(ele);
      w = parseInt(styles.width, 10);

      document.addEventListener("mousemove", mouseMoveHandlerRight);
      document.addEventListener("mouseup", mouseUpHandlerRight);
    };

    const mouseDownHandlerLeft = function (e) {
      x = e.clientX;

      const styles = window.getComputedStyle(ele);
      w = parseInt(styles.width, 10);

      document.addEventListener("mousemove", mouseMoveHandlerLeft);
      document.addEventListener("mouseup", mouseUpHandlerLeft);
    };

    const mouseDownHandlerUp = function (e) {
      y = e.clientY;

      const styles = window.getComputedStyle(ele);
      h = parseInt(styles.height, 10);

      document.addEventListener("mousemove", mouseMoveHandlerUp);
      document.addEventListener("mouseup", mouseUpHandlerUp);
    };

    const mouseDownHandlerDown = function (e) {
      y = e.clientY;

      const styles = window.getComputedStyle(ele);
      h = parseInt(styles.height, 10);

      document.addEventListener("mousemove", mouseMoveHandlerDown);
      document.addEventListener("mouseup", mouseUpHandlerDown);
    };

    const mouseMoveHandlerUp = function (e) {
      // How far the mouse has been moved
      const dy = e.clientY - y;

      // Adjust the dimension of element
      ele.style.height = `${h - dy}px`;
    };

    const mouseMoveHandlerDown = function (e) {
      // How far the mouse has been moved
      const dy = e.clientY - y;

      // Adjust the dimension of element
      ele.style.height = `${h + dy}px`;
    };

    const mouseMoveHandlerRight = function (e) {
      // How far the mouse has been moved
      const dx = e.clientX - x;

      // Adjust the dimension of element
      ele.style.width = `${w + dx}px`;
    };

    const mouseMoveHandlerLeft = function (e) {
      // How far the mouse has been moved
      const dx = e.clientX - x;

      // Adjust the dimension of element
      ele.style.width = `${w - dx}px`;
    };

    const mouseUpHandlerUp = function () {
      // Remove the handlers of `mousemove` and `mouseup`
      document.removeEventListener("mousemove", mouseMoveHandlerUp);
      document.removeEventListener("mouseup", mouseUpHandlerUp);
    };

    const mouseUpHandlerDown = function () {
      // Remove the handlers of `mousemove` and `mouseup`
      document.removeEventListener("mousemove", mouseMoveHandlerDown);
      document.removeEventListener("mouseup", mouseUpHandlerDown);
    };

    const mouseUpHandlerRight = function () {
      // Remove the handlers of `mousemove` and `mouseup`
      document.removeEventListener("mousemove", mouseMoveHandlerRight);
      document.removeEventListener("mouseup", mouseUpHandlerRight);
    };

    const mouseUpHandlerLeft = function () {
      // Remove the handlers of `mousemove` and `mouseup`
      document.removeEventListener("mousemove", mouseMoveHandlerLeft);
      document.removeEventListener("mouseup", mouseUpHandlerLeft);
    };
    // Query all resizers
    const resizersRight = ele.querySelectorAll(".resizer-r");
    const resizersUp = ele.querySelectorAll(".resizer-t");
    const resizersDown = ele.querySelectorAll(".resizer-b");
    const resizersLeft = ele.querySelectorAll(".resizer-l");

    [].forEach.call(resizersRight, function (resizer) {
      resizer.addEventListener("mousedown", mouseDownHandlerRight);
    });

    [].forEach.call(resizersUp, function (resizer) {
      resizer.addEventListener("mousedown", mouseDownHandlerUp);
    });

    [].forEach.call(resizersDown, function (resizer) {
      resizer.addEventListener("mousedown", mouseDownHandlerDown);
    });

    [].forEach.call(resizersLeft, function (resizer) {
      resizer.addEventListener("mousedown", mouseDownHandlerLeft);
    });
  },
};
</script>
